let draw = (number, format) => {
  const canvas = document.getElementById("business")
  const ctx = canvas.getContext("2d")
  ctx.clearRect(0, 0, 150, 20)
  changeResolution(canvas, 2.5)
  ctx.font = "15px sans-serif"
  ctx.fillStyle = "#4d4d4d"
  ctx.fillText(`${Shopify.formatMoney(number * 1.2, format)} (inc VAT)`, 0, 15)
}

window.Shopify.draw = draw
function changeResolution(canvas, scaleFactor) {
  // Set up CSS size.
  canvas.style.width = "150px"
  canvas.style.height = "20px"

  // Resize canvas and scale future draws.
  canvas.width = Math.ceil(150 * scaleFactor)
  canvas.height = Math.ceil(20 * scaleFactor)
  var ctx = canvas.getContext("2d")
  ctx.scale(scaleFactor, scaleFactor)
}
